import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
    home: {
        loading:"Loading...",
        contact_one:"Professional Guidance",
        contact_two:"(WeChat)",
        call_number:"(+86)178-5702-6974",
        last_update:"Last updated: ",
    },
    topBar: {
        searchPlaceholder:"Enter the search keyword",
        helpCenter:"HELP CENTER",
        detail:"Easy to achieve automated processes without complex programming",
    },
    word:{
        tip:"Tips",
        confirm:"Confirm",
        cancel:"Cancel",
        setting:"Setting",
        save:"Save",
    },
    api: {
        requestError:"Request Error"
    }
}
export default en;
